import React, { memo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { priceToNumber, formatNumber } from '../../helpers/utils';

export default memo(function StockDetail(props) {
    const { t } = useTranslation();

    //
    const { counter, code, stockInfo } = props;

    // Tinh toan mua ban chu dong
    const _totalBuyQtty = priceToNumber(stockInfo.totalBuyQtty);
    const _totalSellQtty = priceToNumber(stockInfo.totalSellQtty);
    const _total = _totalBuyQtty + _totalSellQtty;
    let bTotalQttyW = '50', oTotalQttyW = '50';
    if(_total != 0) {
        bTotalQttyW = (_totalBuyQtty / _total * 100).toFixed(0);
        oTotalQttyW = (_totalSellQtty / _total * 100).toFixed(0);
    }

    //
    return (
        <>
            <div className="titletabs">{t("tongQuan")}</div>
            <table className="tabletabs">
                <tbody>
                    <tr>
                        <td>{t("thamChieu")}</td>
                        <td className="text-right"><span className="cl_yl font-weight-500">{stockInfo.refPrice}</span></td>
                    </tr>
                    <tr>
                        <td>{t("moCua")} - {t("dongCua")}</td>
                        <td className="text-right">
                            <span className={"font-weight-500 " + (stockInfo.openPrice_color ?? '')}>{stockInfo.openPrice}</span>
                            <span> - </span>
                            <span className={"font-weight-500 " + (stockInfo.closePrice_color ?? '')}>{stockInfo.closePrice}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("thap")} - {t("cao")} / {t('tb')}</td>
                        <td className="text-right">
                            <span className={"font-weight-500 " + (stockInfo.lowestPrice_color ?? '')}>{stockInfo.lowestPrice}</span>
                            <span> - </span>
                            <span className={"font-weight-500 " + (stockInfo.highestPrice_color ?? '')}>{stockInfo.highestPrice}</span>
                            <span> / </span>
                            <span className={"font-weight-500 " + (stockInfo.avgPrice_color ?? '')}>{stockInfo.avgPrice}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{t("tongKLKhop")}</td>
                        <td className="text-right"><span className="font-weight-500">{formatNumber(stockInfo.totalTradedQttyNM)}</span></td>
                    </tr>
                    <tr>
                        <td>{t("tongGTKhop")}</td>
                        <td className="text-right"><span className="font-weight-500">{formatNumber(stockInfo.totalTradedValueNM)}</span></td>
                    </tr>
                    <tr>
                        <td>{t("klKhopTB10Ngay")}</td>
                        <td className="text-right"><span className="font-weight-500">{formatNumber(stockInfo.avgTotalTradedQtty10Days)}</span></td>
                    </tr>
                </tbody>
            </table>

            <div style={{paddingTop: 10, paddingBottom: 20}}>
                <div className="titletabs" style={{border: 'none'}}>{t("klMuaBanChuDong")}</div>
                <div className="buysell" style={{gap: 0}} >
                    <div className="mr4px">{t("mua")}</div>
                    <div style={{height: 24, lineHeight: '24px', padding: 0, width: bTotalQttyW + '%'}} className="position-relative bg-opacity bg-up clr-up" title={bTotalQttyW + "%"}><span style={{position: 'absolute', left: '6px'}}>{bTotalQttyW}%</span></div>
                    <div style={{height: 24, lineHeight: '24px', padding: 0, width: oTotalQttyW + '%'}} className="position-relative bg-opacity bg-down clr-down text-right" title={oTotalQttyW + "%"}><span style={{position: 'absolute', right: '6px'}}>{oTotalQttyW}%</span></div>
                    <div className="ml4px">{t("ban")}</div>
                </div>
            </div>
        </>
    )
}, (prevProps, nextProps) => {
    if (prevProps.code === nextProps.code && prevProps.counter === nextProps.counter) {
        return true; // props are equal
    }
    return false; // props are not equal -> update the component
})
